import axios from "../axios";

export const get_message_list = (params) => {
    return axios('get', '/api/message/get_message_list', params);
}